import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { PriceVisibilityProvider } from "./context/PriceVisibilityContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AppShell from "./components/AppShell";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import CustomerDetailPage from "./pages/CustomerDetailPage";
import ProfilePage from "./pages/ProfilePage";
import AdminPage from "./pages/AdminPage";
import ReceiptPage from "./pages/ReceiptPage";

function App() {
  return (
    <AuthProvider>
      <PriceVisibilityProvider>
        <BrowserRouter>
        <Toaster position="top-center" richColors closeButton dir="rtl" />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <AppShell><DashboardPage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/customer/:id"
            element={
              <ProtectedRoute>
                <AppShell><CustomerDetailPage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <AppShell><ProfilePage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute adminOnly>
                <AppShell><AdminPage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/receipt/:customerId/:paymentId"
            element={
              <ProtectedRoute>
                <ReceiptPage />
              </ProtectedRoute>
            }
          />
        </Routes>
        </BrowserRouter>
      </PriceVisibilityProvider>
    </AuthProvider>
  );
}

export default App;
